import configureStore from './configureStore';
import {connectStore, setUseId} from '../helpers/api.js';
import { getRouter } from '../helpers/routes.js';
import { getLocale} from '../helpers/locale.js';
import { getHistory} from '../helpers/history.js';
import { default_state} from '../reducers/index.js';
import { ViewTypes} from '../reducers';
import { getInitialState as UIgetInitialState } from '../reducers/ui.reducer.js';
import { createLogger } from '../helpers/server.logger.js';
import * as actions from '../actions/options.action.js';
import * as helperActions from '../actions/helpers.action.js';

export default function setupStore(options) {
    const router = getRouter(options.routes);
    const getDef = getLocale(options.locale);

    if (options.view == ViewTypes.SIDE_PANE) {
        options.history = 'memory';
    }

    const history = getHistory(options.history);
    let state = global.__STATE__ || {};
    state = state.tbs || {};
    let ui_state = UIgetInitialState();

    let store = configureStore({tbs:{
        ...default_state,
        ...state,
        ui : {
            ...ui_state
        },
        helpers : {
            buildRoute : router.buildRoute,
            routes : router.routes,
            getDef
        }
    }}, !!options.disable_logs);

    const app_id = connectStore(store);

    store.dispatch(actions.setOptions(options));
    store.dispatch(actions.setAppOptions({id : app_id, user_id: options.user_id}));

    let logger = createLogger(options.loggerOptions, store);
    store.dispatch(helperActions.setLogger(logger));
    setUseId(app_id, options.use_id_identifier);


    return {
        store : store,
        router : router,
        history : history
    }
}


// WEBPACK FOOTER //
// ./src/store/setupStore.js